<template>
  <app-modal @closeModal="closeModal" :container-class="`modal-${size} confirmation-modal`">
    <div v-if="headerText" slot="header">
      <h3>{{ headerText }}</h3>
    </div>
    <div slot="body">
      <slot name="body">
        <p :class="messageClasses">{{ message }}</p>
      </slot>
    </div>
    <div slot="footer">
      <div class="btn-container">
        <button
          v-if="confirmLast"
          class="btn btn-default btn-sm mr10"
          tabindex="1"
          :disabled="isLoading"
          v-on:click="(e) => closeModal(e)"
        >
          {{ $t("confirmation.cancel") }}
        </button>
        <button v-if="showDeleteButton" class="btn btn-danger btn-sm mr10" tabindex="0" v-on:click.prevent="$emit('confirmAction')" :disabled="isLoading">
          {{ confirmButtonText || $t('messages.confirm_delete.delete') }}
        </button>
        <button v-else-if="showConfirmButton" class="btn btn-carma btn-sm mr10" v-on:click.prevent="$emit('confirmAction')" :disabled="disableConfirmButton || isLoading">
          <span v-if="isLoading">
            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            <span class="visually-hidden" role="status">Loading...</span>
          </span>
          {{ confirmButtonText || $t("confirmation.confirm") }}
        </button>
        <button
          v-if="!confirmLast"
          class="btn btn-default btn-sm"
          tabindex="1"
          :disabled="isLoading"
          v-on:click="(e) => closeModal(e)"
        >
          {{ $t("confirmation.cancel") }}
        </button>
      </div>
    </div>
  </app-modal>
</template>

<script>
  import Modal from './modal';
  import i18n from '../i18n';

  export default {
    props: {
      headerText: {
        type: String,
        required: false
      },
      message: {
        type: String,
        default: () => i18n.t('confirmation.message.default')
      },
      showDeleteButton: {
        type: Boolean,
        default: false
      },
      disableConfirmButton: {
        type: Boolean,
        default: false
      },
      forceTabIndex: Boolean,
      size: {
        type: String,
        default: 'sml'
      },
      isLoading: {
        type: Boolean,
        default: false
      },
      messageClasses: {
        type: String,
        default: ''
      },
      showConfirmButton: {
        type: Boolean,
        default: true
      },
      confirmButtonText: {
        type: String,
        default: ''
      },
      confirmLast: {
        type: Boolean,
        default: false
      }
    },
    components: {
      'app-modal': Modal
    },
    mounted() {
      if(this.forceTabIndex) { // force to switch focus between buttons
        this.buttons = this.$el.getElementsByTagName('button');
        this.buttons[this.tabIndex].focus();
        // attach event listener on window
        window.addEventListener('keydown', this.handleKeydown);
      }
    },
    beforeDestroy() {
      if(this.forceTabIndex) {
        window.removeEventListener('keydown', this.handleKeydown);
      }
    },
    data() {
      return {
        tabIndex: 0,
        buttons: null
      }
    },
    methods: {
      closeModal(e) {
        if(e) {
          e.preventDefault();
          e.stopPropagation();
        }

        this.$emit('cancelAction');
      },
      handleKeydown(e) {
        e.preventDefault();
        if(e.keyCode === 9) { // Tab key
          this.tabIndex = !this.tabIndex ? 1 : 0
          this.buttons[this.tabIndex].focus()
        } else if(e.keyCode === 13) { // Enter key
          this.buttons[this.tabIndex].click()
        } else if(e.keyCode === 27) { // Esc key
          this.closeModal()
        }
      }
    }
  }
</script>